// API response models
export interface ComplianceStatusHttpModel {
  dueNow: number;
  updateSoon: number;
  upToDate: number;
  soonestExpiryDate: string;
}

export enum ComplianceDocumentTypeEnum {
  mandatory = 'Mandatory',
  optional = 'Optional',
}
export enum ComplianceDocumentStatusEnum {
  upToDate = 'UpToDate',
  updateSoon = 'UpdateSoon',
  inProgress = 'InProgress',
  inReview = 'InReview',
  rejected = 'Rejected',
  dueNow = 'DueNow',
}

export enum ComplianceDocumentDocumentTypeEnum {
  training = 'Training',
  compliance = 'Compliance',
  workbook = 'CompetencyAssessment',
  annualUpdate = 'AnnualUpdate',
  notUpdatable = 'NotUpdatable',
}
export interface ComplianceDocument {
  id: number;
  name: string | null;
  lastModified: string | null;
  type: ComplianceDocumentTypeEnum;
  description: string | null;
  expiryDate: string | null;
  status: ComplianceDocumentStatusEnum;
  duration: string | null;
  documentType: ComplianceDocumentDocumentTypeEnum;
  rejectionReason: string | null;
  // note: applicable only for type.training
  trainingCourseDate: string | null;
  trainingCourseName: string | null;
  trainingCourseProvider: string | null;
}

export type CallCentreStatus = 'Ok' | 'NotNow' | 'Lapsed';

export interface ComplianceDocumentUpdateUrlHttpModel {
  url: string;
}
